import React from 'react';

function CompanyName(props) {
    return (<div className={"text-center"}>{props.companyName}</div>)
}
export default CompanyName;
